import { createQueryKeys } from '@lukemorales/query-key-factory';

export const DISCOUNT = createQueryKeys('discount', { list: [''] });
